(function () {
  'use strict';

  var STORAGE_KEY = 'dime_baseline_country';
  var WARNED_KEY = 'dime_last_warned_country';
  var MODAL_ID = 'app-intl-modal';
  var MODAL_OPEN_CLASS = '-is-open';
  var TRIGGER_SELECTOR = '[data-modal="' + MODAL_ID + '"]';

  function getActiveCountry() {
    var current = document.querySelector('.js-country-switch[data-current="true"]');
    return current ? current.getAttribute('data-country') : null;
  }

  function isUS(countryCode) {
    return countryCode === 'US';
  }

  // Swaps the modal header to the mismatch message, hiding the other two
  // header states ('default' and 'first-visit init'), or restores the
  // default header when state isn't 'mismatch'.
  function setModalHeaderState(modal, state) {
    var defaultHeader = modal.querySelector('.app-intl-modal__default-header');
    var initHeader = modal.querySelector('.app-intl-modal__init-header');
    var mismatchHeader = modal.querySelector('.app-intl-modal__mismatch-header');

    if (defaultHeader) defaultHeader.classList.toggle('hidden', state === 'mismatch');
    if (initHeader) initHeader.classList.add('hidden');
    if (mismatchHeader) mismatchHeader.classList.toggle('hidden', state !== 'mismatch');
  }

  // The ft-modal custom element toggles '-is-open' on itself for every close
  // path (X button, backdrop click, Escape key), so watching that class is
  // the reliable way to know the modal was dismissed and restore its header.
  function watchModalClose(modal) {
    if (modal.dataset.mismatchWatcherAttached) return;
    modal.dataset.mismatchWatcherAttached = 'true';

    var observer = new MutationObserver(function () {
      if (!modal.classList.contains(MODAL_OPEN_CLASS)) {
        setModalHeaderState(modal, 'default');
      }
    });
    observer.observe(modal, { attributes: true, attributeFilter: ['class'] });
  }

  function showMismatchWarning() {
    var trigger = document.querySelector(TRIGGER_SELECTOR);
    var modal = document.getElementById(MODAL_ID);
    if (!trigger || !modal) return;

    watchModalClose(modal);
    setModalHeaderState(modal, 'mismatch');
    // The theme's own "-init-header" state (shown when it has no localStorage
    // 'country' value yet) uses higher-specificity CSS that can otherwise
    // out-rank our 'hidden' class on the other two header blocks.
    modal.classList.remove('-init-header');
    trigger.click();
  }

  // Closing the popup (X / outside tap / Escape) submits the form through form.submit(),
  // which fires no submit event, so the theme never saves its "country" flag and reopens
  // the popup on every page load. Treat closing as confirming the selected country.
  function rememberCountryOnClose() {
    var modal = document.getElementById(MODAL_ID);
    var form = modal && modal.querySelector('form');
    if (!form) return;

    var nativeSubmit = HTMLFormElement.prototype.submit;
    form.submit = function () {
      try {
        var input = form.querySelector('input[name="country_code"]');
        if (input && input.value) {
          window.localStorage.setItem('country', JSON.stringify(input.value));
        }
      } catch (e) {}
      return nativeSubmit.call(form);
    };
  }
  rememberCountryOnClose();

  var current = getActiveCountry();
  if (!current) return; // safety: bail if we can't find the modal on this page

  var baseline = localStorage.getItem(STORAGE_KEY);

  if (!baseline) {
    // First-ever visit: record Shopify's own geoIP guess as the baseline, don't warn yet
    localStorage.setItem(STORAGE_KEY, current);
    return;
  }

  var lastWarned = localStorage.getItem(WARNED_KEY);

  if (isUS(baseline) !== isUS(current)) {
    if (current !== lastWarned) {
      showMismatchWarning();
      localStorage.setItem(WARNED_KEY, current);
    }
  } else {
    // They're back on the correct side — clear so a future mismatch can warn again
    localStorage.removeItem(WARNED_KEY);
  }
})();
